import HttpError from "../http_error";
import weatherRoutingAxiosInstance from "../weather_routing_axios_instance";

// TODO: Add try catch for mapping errors

export default class WeatherRoutingVoyageService {
  constructor(baseUrl, companyId, createVoyageToJsonMapper, voyageDataFromJsonMapper, calculationStateDataFromJsonMapper,) {
    this.baseUrl = baseUrl;
    this.companyId = companyId;
    this.createVoyageToJsonMapper = createVoyageToJsonMapper;
    this.voyageDataFromJsonMapper = voyageDataFromJsonMapper;
    this.calculationStateDataFromJsonMapper = calculationStateDataFromJsonMapper;
  }

  async post(accessToken, theyrAccessToken, body) {
    const params = this.createVoyageToJsonMapper(body);

    const requestParams = {
      method: "POST",
      url: `${this.baseUrl}/voyage`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "access-token": `${accessToken}`,
        "theyr-token": `${theyrAccessToken}`,
        data: "{\"verified\":false}",
      },
      data: params
    };

    try {
      const response = await weatherRoutingAxiosInstance.request(requestParams);
      return this.voyageDataFromJsonMapper(response.data);
    } catch (error) {
      if (error.response.status === 402) {
        throw new HttpError(error.response.data.detail, error.response.status);
      }
      else {
        throw new HttpError(error.response.statusText, error.response.status);
      }
    }
  }

  async getMany(accessToken, theyrAccessToken, offset = 0) {
    const response = await weatherRoutingAxiosInstance.get(
      `${this.baseUrl}/voyage`,
      {
        accept: "application/json",
        headers: {
          "access-token": `${accessToken}`,
          "theyr-token": `${theyrAccessToken}`,
        },
        params: {
          company_id: this.companyId,
          limit: 10,
          offset_step: offset
        }
      }
    );

    if (response.status >= 200 && response.status < 400) {
      const result = response.data.map((datum) => this.voyageDataFromJsonMapper(datum));
      return result;
    }
    else {
      throw HttpError(response.statusText, response.status);
    }
  }

  async delete(accessToken, theyrAccessToken, id, theyrId) {
    const response = await weatherRoutingAxiosInstance.delete(
      `${this.baseUrl}/voyage/${id}`,
      {
        accept: "application/json",
        headers: {
          "access-token": `${accessToken}`,
          "theyr-token": `${theyrAccessToken}`,
        },
        params: {
          theyr_id: theyrId
        }
      }
    );
    if (response.status >= 200 && response.status < 400) {
      return response.data;
    }
    else {
      throw HttpError(response.statusText, response.status);
    }
  }

  async postVoyageCalculation(accessToken, theyrAccessToken, id) {

    const requestParams = {
      method: "POST",
      url: `${this.baseUrl}/computation/${id}`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "access-token": `${accessToken}`,
        "theyr-token": `${theyrAccessToken}`,
        data: "{\"verified\":false}",
      },
    };
    try {
      const response = await weatherRoutingAxiosInstance.request(requestParams);
      if (response.status >= 200 && response.status < 400) {
        return response.data;
      }
      return this.calculationStateDataFromJsonMapper(response.data);
    }
    catch (error) {
      if (error.response.status === 402) {
        throw new HttpError(error.response.data.detail, error.response.status);
      }
      else {
        throw new HttpError(error.response.statusText, error.response.status);
      }
    }
  }

  async getVoyageCalculationState(accessToken, theyrAccessToken, id) {
    try {
      const response = await weatherRoutingAxiosInstance.get(
        `${this.baseUrl}/computation/${id}/state`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`,
          },
        }
      );
      return this.calculationStateDataFromJsonMapper(response.data);
    } catch (error) {
      throw new HttpError(error.response.data.detail, error.response.status);
    }
  }
}
